export default "__VITE_ASSET__BJJT$nly__"